module.exports = __webpack_public_path__ + "img/office365.1a55e7b9.svg";